import { adminHttpClient } from '../../../commons/adminHttpClient'
import PagedList from '../../../commons/pagedList'
import OrderedPageFilter from '../../../commons/orderedPageFilter'

export type PerksReimbursementHistoryResponse = {
  firstName: string
  lastName: string
  category: string
  scheduledDate: Date
  serviceProvider: string
  expenseAmount: number
}

export type PerksReimbursementHistoryFilter = OrderedPageFilter & {
  fromDate?: string
  toDate?: string
  planPeriodId: string
}
const getPerksReimbursementHistory = (
  filter: PerksReimbursementHistoryFilter,
): Promise<PagedList<PerksReimbursementHistoryResponse>> => {
  return adminHttpClient.get(`/AdminDashboard/GetPerksReimbursementsHistory`, filter)
}

export default getPerksReimbursementHistory
